import React from "react";
import { Carousel } from "../../components/Carousel";
import { Testimonial } from "./Testimonial";
import { testimonialsType } from "../../types/product";
import { sanitizeHTML } from "../../../search/utils";

interface TestimonialsProps {
	testimonials: testimonialsType;
	title?: string;
}

export function Testimonials({
	testimonials,
	title = "Why 800+ companies like Airbus <br /> and Delta trust ch-aviation",
}: TestimonialsProps) {
	const productSlides = testimonials.map((item, index) => (
		<Testimonial key={index} item={item} />
	));

	if (testimonials.length === 0) {
		return null;
	}

	return (
		<section className="section--testimonials">
			<div className="container typography">
				<h2
					className="section-title"
					dangerouslySetInnerHTML={{
						__html: sanitizeHTML(title),
					}}
				></h2>
				<Carousel slides={productSlides} />
			</div>
		</section>
	);
}
